import { defineComponent, ref } from "vue";
import POSConfigModule from "@/store/modules/pos-config";
export default defineComponent({
  name: "CompleteWithBalanceSettings",
  components: {},
  setup: function setup() {
    var status = ref(POSConfigModule.completeBookingWithBalance);

    var toggleStatus = function toggleStatus(newStatus) {
      status.value = newStatus;
    };

    return {
      status: status,
      toggleStatus: toggleStatus
    };
  }
});